module.exports = __webpack_public_path__ + "img/EY__nav-bg.ceb792db.png";